module.exports = __webpack_public_path__ + "static/media/Armi Behzad.245dc5f9.png";